import { FC, useEffect, useRef } from 'react';
import styles from './TabMenuProfile.module.scss';
import { NavLink } from 'react-router-dom';

type listType = {
  key: string;
  name: string;
};

type TabMenuProps = {
  setActive: (key: string) => void;
  active: string;
  lists?: listType[];
  cls?: React.CSSProperties;
  action?: React.ReactNode;
};

export const TabMenuProfile: FC<TabMenuProps> = ({
  setActive,
  lists = [],
  cls,
  action,
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const handlerActive = (key: string) => {
    setActive(key);
  };

  const keyLists = lists.map((el) => el.key);

  useEffect(() => {
    const path = window.location.pathname;
    keyLists.forEach((el) => {
      if (path.includes(el)) {
        setActive(el);
      }
    });
  }, []);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleWheel = (e: WheelEvent) => {
      const target = e.target as HTMLElement;
      if (!container.contains(target)) return;

      e.preventDefault();

      container.scrollLeft += e.deltaY;
    };

    container.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.root} style={cls} ref={scrollContainerRef}>
        {lists.map((item: listType, i: number) => (
          <NavLink
            to={i !== 0 ? `/profile/${item.key}` : '/profile'}
            end={i === 0}
            key={i}
            className={({ isActive }) =>
              `${styles.item} ${isActive ? styles.active : ''}`
            }
            onClick={() => handlerActive(item.key)}>
            {item.name}
          </NavLink>
        ))}
      </div>
      {action && <div className={styles.actionWrapper}>{action}</div>}
    </div>
  );
};
